var crisisMessage = jq('.crisis-messaging');
if (crisisMessage.length) {
    jq('.crisis-messaging a[href="#"]').click(function(e){
        e.preventDefault();
        crisisMessage.addClass('hide');
    });
    var crisisMessageTimestamp = crisisMessage.data('timestamp');
    var crisisMessageCookieName = 'eqMajorAnnouncement';
    var crisisMessageCookie = Cookies.get(crisisMessageCookieName);
    if (crisisMessageCookie != crisisMessageTimestamp) {
        crisisMessage.removeClass('hide');
        Cookies.set(crisisMessageCookieName, crisisMessageTimestamp, {secure: true, domain: window.location.hostname, expires: 7 });
    }
}